import ClientGlobalSearch from './ClientGlobalSearch';

export default ClientGlobalSearch;
